import type { DetailTabelaProps } from "./types-detail-tabela";
import { DetailTabelaView } from "./view-detail-tabela";

export function DetailTabela(props: DetailTabelaProps) {
  return <DetailTabelaView {...props} />;
}

export type * from "./types-detail-tabela";
